/**
 * Class description
 *
 * Created: 2018-10-09
 * @author jonas
 */
import {DirtyWildGameMode} from "../game/features/DirtyWildsRespinZeroBetController";

export class DirtyWildColorConfig {
    static WIN_DARKENING_COLOR:string = "#000000";
    static WIN_DARKENING_COLOR_AMOUNT:number = 0.3;
    static WIN_DARKENING_COLOR_AMOUNT_BIG_WIN:number = 0.5;


    public static getModeColor(mode:DirtyWildGameMode) {
        switch(mode) {
            case DirtyWildGameMode.STICKY_RESPIN:
                return "#0015ff";
            default:
                return "#44ff00";
        }
    }

    public static getNoWinSymbolModeColor(mode:DirtyWildGameMode) {
        switch(mode) {
            case DirtyWildGameMode.STICKY_RESPIN:
                return "#5a5f9e"; //#5a5f9e
            default:
                return "#D4D6D6";
        }
    }

    public static get randomFeatureColor():string {
        return "#0015ff";
    }

    static getWinDarkeningAmount(isBigWin:boolean) {
        return isBigWin ? DirtyWildColorConfig.WIN_DARKENING_COLOR_AMOUNT_BIG_WIN : DirtyWildColorConfig.WIN_DARKENING_COLOR_AMOUNT
    }
}